import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SessionData } from 'src/app/shared/localstorage/sessionData';

@Injectable({
  providedIn: 'root'
})
export class RoleRedirectHomeGuard implements CanActivate {
  constructor(
    public authService: AuthService, 
    private router: Router
  ) {}

  canActivate(): boolean {
    console.log("canactivate")
    const isAdmin = SessionData.getCurrentUser().admin;

    if (isAdmin) {
      this.router.navigate(['/admin']);
    } else {
      this.router.navigate(['/home']);
    }
    
    // Siempre retornamos false porque estamos manejando la redirección manualmente
    return false;
  }
  
}
